module.exports = __webpack_public_path__ + "img/worm-prepared-mask.67d300c6.png";